import React from 'react'
import { Details } from './style'

export default ({ children, minHeight = 'auto', isHorizontal = false }) => (
  <Details minHeight={minHeight} isHorizontal={isHorizontal}>
    {children}
  </Details>
)
